/** @jsxImportSource @emotion/react */
'use memo'

import { ROUTES } from '@sportninja/common/constants/app'
import PlayerSuspensionsList from 'src/components/PlayerSuspensionsList'
import PlayerStatsBySeason from '../../Profile/v2/PlayerStatsBySeason'
import { sortByDate } from '../helpers/profileFormatting'
import { ProfilePageConfig, ProfilePlayer, ProfileSuspension } from '../types'

const LegacyPlayerStatsBySeason = PlayerStatsBySeason as any

interface UseProfilePagesParams {
  showStats: boolean
  selfPlayerIds: Array<string | number>
  players: ProfilePlayer[]
  suspensionLoading: boolean
  suspensions: ProfileSuspension[] | undefined
  setShowStats: (value: boolean) => void
}

export const useProfilePages = ({
  showStats,
  selfPlayerIds,
  players,
  suspensionLoading,
  suspensions,
  setShowStats,
}: UseProfilePagesParams): ProfilePageConfig[] => {
  return [
    showStats
      ? {
          text: 'Stats',
          to: ROUTES.PROFILE.ROOT,
          component: (
            <LegacyPlayerStatsBySeason
              playerIds={selfPlayerIds}
              setShowStats={setShowStats}
              players={players as any}
            />
          ),
        }
      : null,
    {
      text: 'Suspensions',
      to: ROUTES.PROFILE.SUSPENSIONS,
      component: (
        <PlayerSuspensionsList
          isProfileView
          loading={suspensionLoading}
          error={null}
          suspensions={sortByDate(suspensions) as any}
        />
      ),
    },
  ].filter(Boolean) as ProfilePageConfig[]
}
